//  @flow
import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import FirstLayout from './FirstLayout';
import SecondLayout from './SecondLayout';
import ThirdLayout from './ThirdLayout';

import {useIsFeatureInTier} from '../../../../../utils/component';

import type {SaveLegalRequest} from '../../api';
import type {AboutUs} from '../../duck';

type Props = {
  aboutUs?: AboutUs,
  layoutSelected: number,
  saveStoreAboutUsConfig: (saveLegalRequest: SaveLegalRequest) => void,
};

export default function SelectLayout(props: Props) {
  const {aboutUs, layoutSelected, saveStoreAboutUsConfig} = props;

  const [aboutUsRequest, setAboutUsRequest] = useState(null);
  const [readyToSubmit, setReadyToSubmit] = useState(false);

  const hasAboutUsInformationFeature = useIsFeatureInTier('STORE_POLICIES');

  const handleSubmitRequest = useCallback((data: SaveLegalRequest) => {
    setAboutUsRequest(data);
  }, []);

  useEffect(() => {
    setAboutUsRequest(null);
  }, [layoutSelected]);

  useEffect(() => {
    if (!!aboutUsRequest) {
      setReadyToSubmit(true);
    } else {
      setReadyToSubmit(false);
    }
  }, [aboutUsRequest]);

  useEffect(() => {
    if (readyToSubmit && aboutUsRequest) {
      saveStoreAboutUsConfig(aboutUsRequest);
    }
  }, [aboutUsRequest, readyToSubmit, saveStoreAboutUsConfig]);

  switch (layoutSelected) {
    case 0:
      return (
        <FirstLayout
          disabled={!hasAboutUsInformationFeature}
          handleSubmitRequest={handleSubmitRequest}
          aboutUs={aboutUs}
        />
      );
    case 1:
      return (
        <SecondLayout
          disabled={!hasAboutUsInformationFeature}
          handleSubmitRequest={handleSubmitRequest}
          aboutUs={aboutUs}
        />
      );
    case 2:
      return (
        <ThirdLayout
          disabled={!hasAboutUsInformationFeature}
          handleSubmitRequest={handleSubmitRequest}
          aboutUs={aboutUs}
        />
      );
    default:
      return null;
  }
}

SelectLayout.propTypes = {
  aboutUs: PropTypes.object,
  layoutSelected: PropTypes.number.isRequired,
  saveStoreAboutUsConfig: PropTypes.func.isRequired,
};
